import { type MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import { type ILeaderboardItem } from '../../../../../common/interfaces';
import { ListItem, UserDialogButton } from '../common/styles';
import { UserAvatar } from '../../UserAvatar/UserAvatar';
import { decodeHtml } from '../../../../../helpers';
import { Points, SpanContainer, TextContent } from './LeaderboardItem.styled';

declare function popUp(url: string, options: unknown): void;

interface ILeaderboardItemProps {
  id: number;
  data: ILeaderboardItem;
  tab: string;
  panelSize: number;
  hasWideSibling: boolean;
}

export const LeaderboardItem = ({ id, data, panelSize, hasWideSibling }: ILeaderboardItemProps) => {
  const intl = useIntl();

  const openUserProfile = (e: MouseEvent<HTMLButtonElement>, userId: string) => {
    e.preventDefault();
    const url = `/user/view/${userId}`;
    popUp(url, {
      popUpTitle: intl.formatMessage({ id: 'profile', defaultMessage: 'Profile' }),
      height: 390,
      focusOnClose: e.currentTarget
    });
  };

  const createActionSourceLink = (item: ILeaderboardItem) => (
    <UserDialogButton
      aria-label={`${intl.formatMessage({ id: 'openProfileDialog', defaultMessage: 'Open profile dialog for' })} ${item.user.name}`}
      onClick={(e) => openUserProfile(e, item.user.id)}
    >
      {decodeHtml(item.user.name)}
    </UserDialogButton>
  );

  return (
    <ListItem data-testid="leaderboard-item" $panelSize={panelSize} $hasWideSibling={hasWideSibling}>
      <SpanContainer>{id}</SpanContainer>
      <SpanContainer>
        <UserAvatar user={data.user} />
      </SpanContainer>
      <TextContent>
        {createActionSourceLink(data)}
        <Points>{data.event.points}</Points>
      </TextContent>
    </ListItem>
  );
};
